import type {
  SecurityReportsListResponse,
  StatusFilter,
  RiskLevelFilter
} from './types';
import { getApiBaseUrl } from './config';

const API_BASE = getApiBaseUrl(
  import.meta.env.VITE_DECISION_API_URL ?? 'http://localhost:4000'
);

export interface FetchSecurityReportsParams {
  page?: number;
  pageSize?: number;
  packageName?: string;
  status?: StatusFilter;
  riskLevel?: RiskLevelFilter;
}

export async function fetchSecurityReports(
  params: FetchSecurityReportsParams = {}
): Promise<SecurityReportsListResponse> {
  const search = new URLSearchParams();

  const page = params.page ?? 1;
  const pageSize = params.pageSize ?? 20;

  search.set('page', String(page));
  search.set('pageSize', String(pageSize));

  if (params.packageName && params.packageName.trim().length > 0) {
    search.set('packageName', params.packageName.trim());
  }

  if (params.status && params.status !== 'ALL') {
    search.set('status', params.status);
  }

  if (params.riskLevel && params.riskLevel !== 'ALL') {
    search.set('riskLevel', params.riskLevel);
  }

  const url = `${API_BASE.replace(/\/$/, '')}/api/security/reports?${search.toString()}`;

  const res = await fetch(url, {
    headers: {
      'Content-Type': 'application/json'
    }
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(
      `Failed to fetch security reports: ${res.status} ${res.statusText} ${text}`
    );
  }

  return res.json();
}
